import React from 'react';
import { resolve } from 'library/helpers/path-resolver';

export { default as Address } from './profile-address';
export { default as AssociatedOrg } from './profile-associated-org';
export { default as AssociatedOrgRequired } from './profile-associated-org-required';
export { default as Input } from './profile-input';
export { default as Phone } from './profile-phone';
export { default as Dropdown } from './profile-select';
export { default as GenderDropdown } from './profile-gender-select';
export { default as RaceDropdown } from './profile-race-select';
export { default as Boolean } from './toggle-field';
export { default as Checklist } from './styled-checklist';
export { default as Textarea } from './profile-textarea';
export { default as MultiSelectDropdown } from './profile-multiselect';
export { default as CollegeInColorado } from 'apps/journey/forms/components/college-in-colorado/college-in-colorado';
export { default as FileUpload } from './profile-upload-file';
export { default as ProfileResume } from './profile-resume';
export { default as ProfileWorkPreferences } from './profile-work-preferences';
export { default as ProfileCareerInterests } from './profile-career-interests';
export { default as ProfileMarkdownType } from './profile-markdown-type';

export class NullField extends React.Component {
  componentDidMount() {
    console.warn(
      `Error trying to render question id: ${resolve(
        this.props,
        'question/id',
        null
      )}`
    );
  }
  render() {
    return null;
  }
}
